<template>
  <div class="src-form position-relative">
    <input
        type="text"
        name="main-search"
        class="form-control"
        placeholder="Поиск....."
        :value="searchTerm"
        @input="onInput"
        autocomplete="off"
    />
    <button
        type="button"
        class="src-btn position-absolute top-50 end-0 translate-middle-y bg-transparent p-0 border-0"
        @click="onSubmit"
    >
      <span class="material-symbols-outlined">search</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "SearchFrom",
  data() {
    return {
      searchTerm: "",
    };
  },
  methods: {
    onInput(event) {
      this.searchTerm = event.target.value;
      this.saveSearchTerm();
    },
    onSubmit() {
      this.saveSearchTerm();
    },
    saveSearchTerm() {
      localStorage.setItem("searchTerm", this.searchTerm);
    },
    clearSearchTerm() {
      this.searchTerm = "";
      localStorage.removeItem("searchTerm");
    },
  },
  watch: {
    $route() {
      this.clearSearchTerm();
    },
  },
  created() {
    const storedSearchTerm = localStorage.getItem("searchTerm");
    if (storedSearchTerm) {
      this.searchTerm = storedSearchTerm;
    }
  },
};
</script>
